import React from "react";
import {Input} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton} from "../../../styles/Butttons";
import styled from "styled-components";

export default function FormPartOne({save, data}) {
   return (
      <>
         <FormStyled onSubmit={save}>
            <Grid>
               <Col large={3}>
                  <Input required type="text" placeholder="Nombre del curso" name="courseName" defaultValue={data.courseName} />
                  <Input required type="hidden" placeholder="Nombre del curso" name="idCourseType" defaultValue={data.idCourseType} />
               </Col>
               <Col large={3} offsetL={0.5}>
                  <Input required type="text" placeholder="Código del certificado" name="courseCode" defaultValue={data.courseCode} />
               </Col>
               <Col large={5} offsetL={0.5}>
                  <Grid>
                     <Col large={5}>
                        <Input required type="date" name="startDate" defaultValue={data.startDate} />
                     </Col>
                     <Col large={2} />
                     <Col large={5}>
                        <Input required type="number" name="endDate" step="any" placeholder="horas" defaultValue={data.endDate} />
                     </Col>
                  </Grid>
               </Col>
            </Grid>

            <Col className="maxMargin">
               <Col large={12}>
                  <Grid>
                     <Col large={5}>
                        <Col large={12}>
                           <Label>Perfil de egreso:</Label>
                        </Col>
                        <Col large={12}>
                           <Input required type="text" placeholder="Texto" name="graduateProfile" defaultValue={data.graduateProfile} />
                        </Col>
                     </Col>
                     <Col large={6} offsetL={1}>
                        <Col large={12}>
                           <Label>Link Eventbrite:</Label>
                        </Col>
                        <Col large={12}>
                           <Input required type="url" name="linkEventBrite" defaultValue={data.linkEventBrite} />
                        </Col>
                     </Col>
                  </Grid>
               </Col>
            </Col>

            {/* Segúnda página */}

            <Col className="maxMargin">
               <Col large={12}>
                  <Grid>
                     <Col large={6} className="imgs">
                        <Label>Imágen Desktop:</Label>
                        <EditableImg
                           editable={true}
                           label="Medidas aprox: 394px X 317px"
                           name="pathImageDesktop"
                           fileName={data.pathImageDesktop}
                        />
                     </Col>
                     <Col large={6} className="imgs">
                        <Label>Imágen Mobile</Label>
                        <EditableImg
                           editable={true}
                           label="Medidas aprox: 394px X 317px"
                           name="pathImageMobile"
                           fileName={data.pathImageMobile}
                        />
                     </Col>
                  </Grid>
               </Col>
            </Col>
            <Grid className="maxMargin">
               <Col large={4}>
                  <Grid>
                     <Col large={12}>
                        <Label>Descripción corta del curso:</Label>
                     </Col>
                     <Col large={12}>
                        <Input
                           required
                           type="text"
                           placeholder="Texto"
                           className="short"
                           name="shortDescription"
                           defaultValue={data.shortDescription}
                           as="textarea"
                        />
                     </Col>
                  </Grid>
               </Col>
               <Col large={7.5} offsetL={0.5}>
                  <Grid>
                     <Col large={12}>
                        <Label>Descripción amplia del curso:</Label>
                     </Col>
                     <Col large={12}>
                        <Input
                           required
                           type="text"
                           placeholder="Texto"
                           className="large"
                           name="longDescription"
                           defaultValue={data.longDescription.replace(/<br>/gi, "\n")}
                           as="textarea"
                        />
                     </Col>
                  </Grid>
               </Col>
            </Grid>

            <Grid className="maxMargin">
               <Col large={2} offsetL={10}>
                  <AppButton>CONTINUAR</AppButton>
               </Col>
            </Grid>
         </FormStyled>
      </>
   );
}

const FormStyled = styled.form`
   padding: 2em 0;
   .buttonModal {
      margin-top: 2em;
   }
   textarea {
      font-family: Montserrat;
      resize: none;
      height: 160px;
   }
   & .maxMargin {
      margin-top: 1em;
   }
   & .imgs {
      & .row {
         width: 100%;
      }
   }

   & .buttonAction {
      text-align: center;
      height: 43px;
      box-sizing: border-box;
      user-select: none;

      &.disabled {
         pointer-events: none;
         color: grey;
         opacity: 0.5;
      }

      & span {
         font-size: 1.1em;
      }
   }
`;
